import { render, staticRenderFns } from "./SdDocumentViewer.html?vue&type=template&id=0dbe866b&external"
import script from "./SdDocumentViewer.ts?vue&type=script&lang=ts&external"
export * from "./SdDocumentViewer.ts?vue&type=script&lang=ts&external"
import style0 from "./SdDocumentViewer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports